/**
 * Texts for User Training page - Italian
 */
export const userTrainingPageText = {
    title: 'Formazione utente - CamAPS FX',
    titleMeta: 'Risorse di formazione complete per gli utenti di CamAPS FX',
    descriptionMeta: 'Accedi a materiali di formazione completi, tutorial video, guide utente e webinar per ottenere il massimo da CamAPS FX.',
    keywords:
        'formazione camaps fx, formazione camaps, formazione diabete, formazione pompa insulina, guida utente, tutorial video',
    localeMeta: 'it_it',

    mainHeader: 'Formazione utente',
    mainSubHeader: 'Completate la formazione essenziale in-app prima di utilizzare l\'app CamAPS FX.',

    gettingStartedHeader: 'Primi passi',
    step1Title: '<strong>Passo 1:</strong><br/>Scaricate l\'app',
    step2Title: '<strong>Passo 2:</strong><br/>Create un account',
    step3Title: '<strong>Passo 3:</strong><br/>Iniziate la formazione essenziale in-app',
    step4Title: '<strong>Passo 4:</strong><br/>Accoppiate con la vostra pompa e CGM scelti (con l\'approvazione del vostro team sanitario) o esplorate l\'app con la <strong>modalità virtuale</strong>',
    videoSrc: '/video/In-app training loop_1.mp4', // Path to video in public folder

    supportSectionTitle: 'Hai bisogno di aiuto per installare l\'app?',
    supportSectionText: 'Visita la nostra sezione di supporto per ricevere assistenza',
    supportButtonText: 'SUPPORTO',
    findOutMoreButtonText: 'SCOPRI DI PIÙ',

    additionalResourcesTitle: 'Risorse aggiuntive',
    additionalResourcesSubtitle: 'Imparate attraverso visuali passo dopo passo o guardate sessioni guidate da esperti sull\'uso dell\'app.',
    
    animationsTitle: 'Animazioni',
    animationsDescription: 'La pompa per insulina Dana è attualmente disponibile commercialmente solo con CamAPS FX nel Regno Unito. Tutte le risorse relative a Dana sono quindi disponibili solo in inglese.',
    animationsLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    
    webinarsTitle: 'Webinar',
    webinarsDescription: 'Questi webinar sono adatti alle persone affette da diabete di tipo 1, alla loro famiglia e ai loro assistenti, nonché agli insegnanti, al personale di supporto all\'istruzione e agli operatori sanitari. Sono presentati in inglese.',
    webinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    factsheetsTitle: 'Schede informative',
    factsheetsDescription: 'La pompa per insulina Dana è attualmente disponibile commercialmente solo con CamAPS FX nel Regno Unito. Tutte le risorse relative a Dana sono quindi disponibili solo in inglese.',
    factsheetsLink: 'https://www.camdiabtraining.com',

    inAppTrainingHeader: 'Formazione in-app',
    inAppTrainingText: 'Iniziate con la formazione essenziale integrata nell\'app CamAPS FX. Questa formazione interattiva vi guiderà attraverso tutte le funzionalità chiave che dovete conoscere.<br/><br/><strong>Per accedere:</strong> Scaricate l\'app CamAPS FX e create un account per iniziare il vostro percorso di formazione in-app.',

    gettingStartedText: '<strong>Passo 1:</strong> Scaricate l\'app CamAPS FX dall\'app store del vostro dispositivo<br/><strong>Passo 2:</strong> Create il vostro account<br/><strong>Passo 3:</strong> Completate i moduli di formazione in-app<br/><strong>Passo 4:</strong> Collegate la vostra pompa per insulina e CGM<br/><strong>Passo 5:</strong> Iniziate il vostro viaggio con CamAPS FX',

    trainingResourcesHeader: 'Risorse di formazione aggiuntive',
    videoTutorialsText: 'Tutorial video',
    videoTutorialsDesc: 'Guardate guide video passo dopo passo su configurazione, uso quotidiano e risoluzione dei problemi.',
    videoTutorialsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    userGuidesText: 'Guide utente & Documentazione',
    userGuidesDesc: 'Scaricate guide PDF complete e materiali di riferimento rapido.',
    userGuidesLink: 'https://www.camdiabtraining.com',
    
    webinarsText: 'Webinar dal vivo',
    webinarsDesc: 'Partecipate a sessioni di formazione guidate da esperti e opportunità di domande e risposte.',

    needHelpHeader: 'Hai bisogno di aiuto?',
    needHelpTextStart: 'Se avete bisogno di assistenza o avete domande, visitate la nostra pagina',
    supportLinkText: 'Supporto',
    needHelpTextEnd: 'per ulteriore aiuto e informazioni di contatto.'
};

